"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _ObfuscationToggle = _interopRequireDefault(require("../ObfuscationToggle"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CopyIcon = function CopyIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.592 3.4A2.004 2.004 0 0 1 12.5 2h3c.893 0 1.652.59 1.908 1.4H18.5c1.102 0 2 .898 2 2V16c0 1.102-.898 2-2 2h-9c-1.102 0-2-.898-2-2V5.4c0-1.102.898-2 2-2h1.092zm-.052 2H9.5V16h9V5.4h-1.04A2.004 2.004 0 0 1 15.5 7h-3a2.004 2.004 0 0 1-1.96-1.6zM12.5 4v1h3V4h-3zm-8 3a1 1 0 0 1 1 1v12H15a1 1 0 1 1 0 2H5.5c-1.102 0-2-.898-2-2V8a1 1 0 0 1 1-1z"
  }));
};
CopyIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "container": "ClippableText__container__29goW",
  "flex-container": "ClippableText__flex-container__XqLQY",
  "flexContainer": "ClippableText__flex-container__XqLQY",
  "clippable-text": "ClippableText__clippable-text__3NIu5",
  "clippableText": "ClippableText__clippable-text__3NIu5",
  "icon-container": "ClippableText__icon-container__2V5ZX",
  "iconContainer": "ClippableText__icon-container__2V5ZX",
  "hidden": "ClippableText__hidden__27Vzl"
}; 
require('./ClippableText.css');
var ClippableText = /*#__PURE__*/function (_React$Component) {
  function ClippableText() {
    var _this;
    (0, _classCallCheck2.default)(this, ClippableText);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ClippableText, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      tooltip: 'Save to clipboard',
      hideButton: true
    });
    (0, _defineProperty2.default)(_this, "handleClick", function () {
      var value = _this.props.value;
      (0, _copyToClipboard.default)(value);
      _this.setState({
        tooltip: 'Saved!'
      });
      setTimeout(function () {
        _this.setState({
          tooltip: null
        });
      }, 1000);
    });
    (0, _defineProperty2.default)(_this, "handleIconKeyDown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        _this.handleClick();
      }
    });
    (0, _defineProperty2.default)(_this, "handleMouseEnter", function () {
      _this.setState({
        hideButton: false,
        tooltip: 'Save to clipboard'
      });
    });
    (0, _defineProperty2.default)(_this, "handleMouseLeave", function () {
      _this.setState({
        hideButton: true
      });
    });
    (0, _defineProperty2.default)(_this, "renderContent", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        value = _this$props.value,
        isObfuscated = _this$props.isObfuscated;
      if (isObfuscated) {
        return /*#__PURE__*/_react.default.createElement(_ObfuscationToggle.default, {
          value: value
        });
      }
      return children || value;
    });
    return _this;
  }
  (0, _inherits2.default)(ClippableText, _React$Component);
  return (0, _createClass2.default)(ClippableText, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        value = _this$props2.value,
        isObfuscated = _this$props2.isObfuscated,
        testId = _this$props2.testId;
      var _this$state = this.state,
        tooltip = _this$state.tooltip,
        hideButton = _this$state.hideButton;
      if (!value || value.length === 0) {
        return /*#__PURE__*/_react.default.createElement("div", {
          "data-test-id": testId,
          className: styles.container
        }, "\u2013");
      }
      var renderIcon = /*#__PURE__*/_react.default.createElement("span", {
        "aria-label": "Copy to clipboard",
        onClick: this.handleClick,
        role: "button",
        tabIndex: "0",
        onKeyDown: this.handleIconKeyDown
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "xs"
      }, /*#__PURE__*/_react.default.createElement(CopyIcon, null)));
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId,
        className: styles.container
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.flexContainer,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.clippableText, isObfuscated ? 'fs-block' : undefined),
        title: value
      }, this.renderContent()), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        className: (0, _classnames.default)(styles.iconContainer, (0, _defineProperty2.default)({}, styles.hidden, hideButton)),
        content: tooltip,
        offset: [0, -5],
        position: "top"
      }, renderIcon)));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ClippableText, "propTypes", {
  children: _propTypes.default.node,
  value: _propTypes.default.string,
  isObfuscated: _propTypes.default.bool,
  testId: _propTypes.default.string
});
(0, _defineProperty2.default)(ClippableText, "defaultProps", {
  isObfuscated: false,
  testId: 'clippable-text'
});
var _default = exports.default = ClippableText;
//# sourceMappingURL=ClippableText.js.map